import React, { useEffect, useState, useRef } from "react";
import { Button, Col } from "react-bootstrap";
import Head from "next/head";
import { getDefYear } from "../../constants/main";
import { appServerSideProps } from "../../utils/getAppService";

import Utils from "../../utils/Utils";
import { getRequest, postRequest } from "../../utils/authGetRequest";
import MainLayout from "../../components/MainLayout/MainLayout";
import MarchMadnessMatchup from "../../assets/images/march-madness-matchup.png";
import CloseIcon from "../../assets/images/close.png";
import SearchIcn from "../../assets/images/search-icn.png";
import { useCookies } from "react-cookie";
import GameCard from "../../components/gamecard/GameCard";
import Skeleton from "react-loading-skeleton";
// import { v4 as uuidv4 } from "uuid";
import Input from "../../components/form/Input";
import { AiOutlineMail } from "react-icons/ai";
import ContentfulBlogs from "../../components/contentfulBlogs/ContentfulBlogs";
import UpdatePlan from "../../components/update-plan/UpdatePlan";
const SectionSearch = ({ rawFilteredDataByDate, setFilteredDataByDate, isDataLoading = false }) => {
  const [homeTeamSearchKey, setHomeTeamSearchKey] = useState("");
  const [displayHomeResults, setDisplayHomeResults] = useState();
  const [homeAutocomplete, setHomeAutocomplete] = useState([]);
  const [awayTeamSearchKey, setAwayTeamSearchKey] = useState("");
  const homeSearchRef = useRef(null);
  const awaySearchRef = useRef(null);

  const [displayAwayResults, setDisplayAwayResults] = useState();
  const [awayAutocomplete, setAwayAutocomplete] = useState([]);

  const [performSearch, setPerformSearch] = useState(false);
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    const tempTeams = rawFilteredDataByDate.map((team) => team["Home_Team"]);
    const oppTeams = rawFilteredDataByDate.map((team) => team["Away_Team"]);
    tempTeams.push(...oppTeams);
    setTeams([...new Set(tempTeams)]);
  }, [rawFilteredDataByDate]);

  const searchByTeam = (searchTerm, searchTeamType) => {
    let filteredTeams = teams.filter((team) => team.toLowerCase().includes(searchTerm.toLowerCase()));

    // if (searchTeamType === "away") {
    //   filteredTeams = rawFilteredDataByDate
    //     .filter((team) => team["Away_Team"].toLowerCase().includes(searchTerm.toLowerCase()))
    //     .map((team) => team["Away_Team"]);
    // } else {
    //   filteredTeams = rawFilteredDataByDate
    //     .filter((team) => team["Home_Team"].toLowerCase().includes(searchTerm.toLowerCase()))
    //     .map((team) => team["Home_Team"]);
    // }

    return Array.from(new Set([...filteredTeams]));
  };

  const searchData = (homeTeam = "", awayTeam = "", searchType = "single") => {
    let newRecords;
    let newRecords2;

    if (searchType === "single") {
      // newRecords = rawFilteredDataByDate.filter((r) => r["Home_Team"] === homeTeam || r["Away_Team"] === awayTeam);
      // newRecords2 = rawFilteredDataByDate.filter((r) => r["Home_Team"] === awayTeam || r["Away_Team"] === homeTeam);
      // newRecords = [...newRecords, ...newRecords2];
      newRecords = rawFilteredDataByDate.filter(
        (r) =>
          r["Home_Team"] === homeTeam ||
          r["Away_Team"] === awayTeam ||
          r["Home_Team"] === awayTeam ||
          r["Away_Team"] === homeTeam
      );
    }

    if (searchType === "double") {
      newRecords = rawFilteredDataByDate.filter(
        (r) =>
          (r["Home_Team"] === homeTeam && r["Away_Team"] === awayTeam) ||
          (r["Home_Team"] === awayTeam && r["Away_Team"] === homeTeam)
      );
    }

    return newRecords;
  };

  const displaySearchData = (e, searchTeamType) => {
    console.log("EXEC...");

    if (searchTeamType === "home") {
      homeSearchRef.current.value = e.target.innerText;
      setHomeTeamSearchKey(e.target.innerText);
    } else {
      setAwayTeamSearchKey(e.target.innerText);
      awaySearchRef.current.value = e.target.innerText;
    }

    if (homeSearchRef && awaySearchRef) {
      setPerformSearch(true);
    }

    //  inputSearchRef.current.value =  e.target.innerText;
    //  setSearchKey(e.target.innerText);
    //  setFilteredDataByDate([...searchData(e.target.innerText)]);
    //  setDisplaySearchResults(false);
  };

  const clearSearch = (e, searchTeamType) => {
    setFilteredDataByDate([]);

    awaySearchRef.current.value = "";
    homeSearchRef.current.value = "";

    setAwayTeamSearchKey("");
    setHomeTeamSearchKey("");

    setDisplayAwayResults(false);
    setDisplayHomeResults(false);

    setPerformSearch(false);
  };

  const onSearchBlur = (e, searchTeamType) => {
    if (searchTeamType === "away") {
      if (e.target.value.length > 0) {
        setTimeout(() => {
          setDisplayAwayResults(false);
        }, 300);
      }
    } else {
      if (e.target.value.length > 0) {
        setTimeout(() => {
          setDisplayHomeResults(false);
        }, 300);
      }
    }
  };

  useEffect(() => {
    setHomeAutocomplete(searchByTeam(homeTeamSearchKey, "home").splice(0, 5));
  }, [homeTeamSearchKey, setHomeTeamSearchKey]);

  useEffect(() => {
    setAwayAutocomplete(searchByTeam(awayTeamSearchKey, "away").splice(0, 5));
  }, [awayTeamSearchKey, setAwayTeamSearchKey]);

  useEffect(() => {
    if (performSearch && homeTeamSearchKey.length > 0 && awayTeamSearchKey.length) {
      setFilteredDataByDate([...searchData(homeTeamSearchKey, awayTeamSearchKey, "double")]);
    } else if (performSearch && awayTeamSearchKey.length > 0) {
      setFilteredDataByDate([...searchData("", awayTeamSearchKey)]);
    } else if (performSearch && homeTeamSearchKey.length > 0) {
      setFilteredDataByDate([...searchData(homeTeamSearchKey, "")]);
    }
  }, [
    performSearch,
    setPerformSearch,
    homeTeamSearchKey,
    setHomeTeamSearchKey,
    awayTeamSearchKey,
    setAwayTeamSearchKey,
  ]);

  return (
    <section style={{ backgroundColor: "#f3f4f6" }}>
      <div className="container">
        {isDataLoading ? (
          <Skeleton height={100} />
        ) : (
          <div className="row">
            <div className="col-sm-12">
              <h3 className="text-center mb-3">Every March Madness Matchup</h3>
            </div>

            <div className="col-sm-2"></div>
            <div className="col-sm-4 position-relative">
              <div className="search position-relative w-100 mb-2">
                <input
                  type="text"
                  placeholder="Search Team 1"
                  className="form-control w-100"
                  onChange={(e) => (setHomeTeamSearchKey(e.target.value), setDisplayHomeResults(true))}
                  onKeyPress={(e) => {
                    // if (e.key === "Enter") {
                    // searchData();
                    // }
                  }}
                  onBlur={(e) => onSearchBlur(e, "home")}
                  ref={homeSearchRef}
                  style={{ borderRadius: "10px" }}
                />
                {homeTeamSearchKey.length > 0 ? (
                  <button
                    type="submit"
                    className="btn"
                    onClick={clearSearch}
                    title="Clear Search Results"
                    style={{
                      position: "absolute",
                      top: "0",
                      right: "0",
                      bottom: "0",
                      margin: "auto",
                      padding: "0 15px 0 0",
                    }}
                  >
                    <img src={CloseIcon.src} alt="" style={{ width: "18px" }} />
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="btn"
                    onClick={searchData}
                    style={{
                      position: "absolute",
                      top: "0",
                      right: "0",
                      bottom: "0",
                      margin: "auto",
                      padding: "0 15px 0 0",
                    }}
                  >
                    <img src={SearchIcn.src} alt="" />
                  </button>
                )}
                {displayHomeResults === true && homeTeamSearchKey.length > 0 ? (
                  <div className="search-results">
                    <h6 className="text-left -2">Teams</h6>
                    {homeAutocomplete.length > 0 ? (
                      homeAutocomplete.map((searchTerm) => (
                        <span
                          key={searchTerm}
                          className="search-results__text"
                          onClick={(e) => displaySearchData(e, "home")}
                        >
                          {searchTerm}
                        </span>
                      ))
                    ) : (
                      <span disabled={true} className="text-center">
                        No Results Found
                      </span>
                    )}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="col-sm-4 position-relative">
              <div className="search position-relative w-100 mb-2">
                <input
                  type="text"
                  placeholder="Search Team 2"
                  className="form-control w-100"
                  onChange={(e) => (setAwayTeamSearchKey(e.target.value), setDisplayAwayResults(true))}
                  onKeyPress={(e) => {
                    // if (e.key === "Enter") {
                    // searchData();
                    // }
                  }}
                  onBlur={(e) => onSearchBlur(e, "away")}
                  ref={awaySearchRef}
                  style={{ borderRadius: "10px" }}
                />
                {awayTeamSearchKey.length > 0 ? (
                  <button
                    type="submit"
                    className="btn"
                    onClick={(e) => clearSearch(e, "away")}
                    title="Clear Search Results"
                    style={{
                      position: "absolute",
                      top: "0",
                      right: "0",
                      bottom: "0",
                      margin: "auto",
                      padding: "0 15px 0 0",
                    }}
                  >
                    <img src={CloseIcon.src} alt="" style={{ width: "18px" }} />
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="btn"
                    onClick={searchData}
                    style={{
                      position: "absolute",
                      top: "0",
                      right: "0",
                      bottom: "0",
                      margin: "auto",
                      padding: "0 15px 0 0",
                    }}
                  >
                    <img src={SearchIcn.src} alt="" />
                  </button>
                )}
                {displayAwayResults === true && awayTeamSearchKey.length > 0 ? (
                  <div className="search-results">
                    <h6 className="text-left -2">Teams</h6>
                    {awayAutocomplete.length > 0 ? (
                      awayAutocomplete.map((searchTerm) => (
                        <span
                          className="search-results__text"
                          onClick={(e) => displaySearchData(e, "away")}
                          key={searchTerm}
                        >
                          {searchTerm}
                        </span>
                      ))
                    ) : (
                      <span disabled={true} className="text-center">
                        No Results Found
                      </span>
                    )}
                  </div>
                ) : null}
              </div>
            </div>

            <div className="col-sm-2"></div>
          </div>
        )}
      </div>
    </section>
  );
};

const SectionGameCard = ({ filterdDataByDate, isDataLoading, isPaidUser, user }) => {
  return filterdDataByDate?.length ? (
    <section className="SectionGameCard" style={{ paddingBottom: "70px" }}>
      <div className="container">
        {isDataLoading ? (
          <GameCard isLoading={true} />
        ) : filterdDataByDate.length > 0 ? (
          filterdDataByDate.map((dt, index) => (
            <GameCard
              data={dt}
              key={dt.Home_Team + dt.Away_Team + index}
              isPaidUser={isPaidUser}
              // render={<ModalContent data={dt} key={uuidv4()} isPaidUser={isPaidUser} />}
            />
          ))
        ) : (
          <GameCard fallBack={true} />
        )}
      </div>
    </section>
  ) : null;
};

const MarchMadnessMatchups = ({ user }) => {
  const isPaidUser = Utils.hasStandardPlan(user) || Utils.hasPremiumPlan(user);
  const [isValid, setIsValid] = useState(false);
  const [cookies, setCookie] = useCookies(["marchmadness_subscribed"]);
  const [marchmadnessSubscribed, setMarchmadnessSubscribed] = useState(true);
  const [predictionData, setPredictionData] = useState([]);
  const [showPurchaseModalOnLoad, setShowPurchaseModalOnLoad] = useState(false);
  const [rawFilteredDataByDate, setRawFilteredDataByDate] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [filterdDataByDate, setFilteredDataByDate] = useState([]);

  const [authToken, setAuthToken] = useState(null);
  const [emailAddress, setEmailAddress] = useState("");

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  useEffect(() => {
    setIsValid(validateEmail(emailAddress));
  }, [emailAddress]);

  const handleSubmit = () => {
    if (isValid) {
      postRequest("/api/marchmadness/email", {
        email: emailAddress,
      });

      setCookie("marchmadness_subscribed", true, {
        maxAge: 31536000,
        path: "/",
      });
      setMarchmadnessSubscribed(true);
    }
  };

  const getPredictionData = () => {
    if (marchmadnessSubscribed || authToken) {
      getRequest(`/api/college_mens/${getDefYear("college_mens")}/marchmadness`)
        .then((response) => response.data)
        .then((response) => {
          if (response.data) {
            Utils.readCsv("teams/Color_Code_for_Teams.csv").then((colorCSV) => {
              let colorCodesMapped = response.data.map((dt) => {
                return {
                  ...dt,
                  Home_Team_Color: colorCSV.filter((x) => x.Teams == dt["Team_1"])[0].Colors,
                  Away_Team_Color: colorCSV.filter((x) => x.Teams == dt["Team_2"])[0].Colors,
                };
              });

              colorCodesMapped = colorCodesMapped.map((dt) => {
                return {
                  ...dt,
                  Home_Team: dt["Team_1"],
                  Away_Team: dt["Team_2"],
                };
              });
              setPredictionData(colorCodesMapped);
            });
          }

          if (!isPaidUser) {
            setTimeout(() => {
              setShowPurchaseModalOnLoad(true);
            }, 1000);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  useEffect(() => {
    if (cookies.token_access) {
      setAuthToken(cookies.token_access);
    }
  }, []);

  useEffect(() => {
    setMarchmadnessSubscribed(cookies.marchmadness_subscribed);
    getPredictionData();
  }, [marchmadnessSubscribed, authToken]);

  useEffect(() => {
    if (predictionData.length > 0) {
      setIsDataLoading(false);
    }
  }, [predictionData]);

  useEffect(() => {
    // setFilteredDataByDate(predictionData);
    setRawFilteredDataByDate(predictionData);
  }, [isDataLoading]);

  return (
    <>
      <Head>
        <title>NCAA Basketball Teams: Odds, Predictions Spreads & More | ShotQuality</title>
        <meta
          name="description"
          content="Explore every NCAA basketball team to easily find odds, predictions, spreads, picks and parlays, and more. ShotQuality
          Bets provides the most accurate, robust and predictable dataset for NCAA college basketball odds, picks and parlays. Access our dataset now to
          unlock all NCAAB odds and easily identify points-of-value for each game."
        />
      </Head>
      <MainLayout>
        {!isPaidUser ? (
          <div style={{ height: "100vh", position: "relative" }}>
            <div className="mt-1 modal-overlay update-plan">
              <UpdatePlan page="matchups" />
            </div>
          </div>
        ) : (
          <div style={{ padding: "0 3.5%" }}>
            <main id="ContentBox" style={{ minHeight: "100vh" }}>
              <div className="MiscStats ValueBracket">
                {/* Start Title side */}
                <div className=" text-center">
                  <div>
                    <div className="dukescroe">
                      <div className="row align-items-center header-container">
                        <div className="box col-md-12 text-md-left ValueBracketTitle">
                          <h2>ShotQuality Matchups</h2>
                          <p vstyle={{ maxWidth: "50%" }}>
                            We use predictive analytics powered by over 50 million data points to analyze every possible
                            matchup for NCAA March Madness. Type in any team to start simulating!
                          </p>
                        </div>
                        {!marchmadnessSubscribed && !authToken ? (
                          <>
                            <div className="col-md-12 dummyLockWrapper">
                              <div className="imgWrapper">
                                <img src={MarchMadnessMatchup.src} className="bracketBackground" alt="" />
                              </div>
                              <div
                                className="dummyLock"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  flexDirection: "column",
                                  position: "absolute",
                                  top: "20px",
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                }}
                              >
                                <h3>Want to see more?</h3>
                                <p>
                                  Unlock ShotQuality Matchups. To see all data on this page, please share with us your
                                  email to get access.
                                </p>
                              </div>
                            </div>

                            <Col
                              xxl={4}
                              lg={6}
                              xl={4}
                              sm={6}
                              md={6}
                              xs={10}
                              className="mx-auto fluid mm-email-submit-col"
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                marginTop: "-600px",
                                zIndex: 999999,
                              }}
                            >
                              <Input
                                className="w-100 input-search form-control mm-email-submit-input"
                                icon={<AiOutlineMail size={20} style={{ marginTop: "5px" }} />}
                                onChange={(e) => setEmailAddress(e.target.value)}
                                style={{
                                  fontSize: "14px",
                                  borderRadius: "8px",

                                  border: "1px solid #ced4da",
                                }}
                                placeholder="Enter your email"
                                aria-label="Username"
                                aria-describedby="basic-addon1"
                              />
                              <Button
                                className="mm-email-submit-input-btn"
                                style={{
                                  backgroundColor: "black",
                                  color: "white",

                                  padding: "5px 15px",
                                }}
                                disabled={!isValid}
                                onClick={() => handleSubmit()}
                              >
                                Get Access
                              </Button>
                            </Col>
                          </>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <SectionSearch {...{ rawFilteredDataByDate, setFilteredDataByDate, isDataLoading }} />
              <SectionGameCard
                filterdDataByDate={filterdDataByDate}
                isDataLoading={isDataLoading}
                isPaidUser={isPaidUser}
                user={user}
              />
            </main>
            <div className="container">
              <ContentfulBlogs user={user} tag="marchMadness" />
            </div>
          </div>
        )}
      </MainLayout>
    </>
  );
};

export default MarchMadnessMatchups;

export const getServerSideProps = appServerSideProps(async ({ appService, cookies, params, query }) => {
  const isUserLogged = appService.getUser();
  let user = null;
  if (isUserLogged) {
    user = await appService.get("api/account");
  }
  return {
    props: {
      user,
    },
  };
});
